<script setup>
import { onMounted, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Keyboard, Autoplay, Pagination, Navigation } from "swiper/modules";
import { useModal } from "vue-final-modal";
import { useModalsStore } from "@/stores/showModals";
import modalContainer from "@/components/modalContainer.vue";

const modalStore = useModalsStore();

const { open: openModal, close: closeModal } = useModal({
  component: modalContainer,
  props: {},
  attrs: {
    onConfirm() {
      closeModal();
    },
  },
});

const hoveredIndex = ref(null);
const itemsCards = [
  // {
  //   country: "Guatemala",
  //   link: "https://www.instagram.com/happypeople.gt/",
  //   image:
  //     "https://cdn.pixabay.com/photo/2016/11/22/19/25/man-1850181_1280.jpg",
  // },
  

  
  {
    country: "08 de Marzo /Cerro Peñon Panamá",
    link: "https://www.instagram.com/hikingtiquicia/ ",
    isTHF: false,
    image: "/images/pacp/columbia-pacp-1.jpg",
    countryCode: "pacp",
  },

  

  {
    country: "29 marzo / Valle de Antón",
    link: "https://www.instagram.com/hikingtiquicia/ ",
    isTHF: false,
    image: "/images/va/columbia-va-1.jpg",
    countryCode: "va",  
  },

  {
    country: "08 Marzo / Finca San Gerardo Cosa Rica",
    link: "https://www.instagram.com/hikingtiquicia/ ",
    isTHF: false,
    image: "/images/crfsg/columbia-crfsg-1.jpg",
    countryCode: "crfsg",
  },
];

//eslint-disable-next-line
const onSwiper = (swiper) => {
  //   console.log(swiper);
};

const onSlideChange = (swiper) => {
  //eslint-disable-next-line
  const activeSlideIndex = swiper.activeIndex;
  //Slider que esta activo
  //   console.log("Slide change: " + activeSlideIndex);
};

const modules = [Keyboard, Autoplay, Pagination, Navigation];

onMounted(async () => {});

const handleHover = (index) => {
  hoveredIndex.value = index;
};
</script>
<template>
  <div class="bg-section sm:h-screen text-black py-10 2xl:py-20">
    <div class="flex flex-col justify-center items-center px-5">
   
      <p class="text-lg lg:text-xl max-w-3xl z-10 text-center mt-1 leading-5">
        Comparte tu experiencia y etiquétanos en tus fotos usando
      </p>
      <h4
        class="text-3xl lg:text-4xl font-bold z-10 text-center max-w-3xl leading-7 xl:leading-9 tracking-tight"
      >
        #COLUMBIAHIKESOCIETY
      </h4>
    </div>
    <div class="justify-center flex mt-4">
      <div class="flex items-center w-full px-5 xl:px-20 mt-10 gap-4 2xl:mt-20">
        <button class="button-prev z-10">
          <svg
            class="-rotate-90"
            xmlns="http://www.w3.org/2000/svg"
            width="14.974"
            height="17.746"
            viewBox="0 0 14.974 17.746"
          >
            <g
              id="Grupo_131"
              data-name="Grupo 131"
              transform="translate(-7430.874 -2098.879)"
            >
              <g id="Grupo_11" data-name="Grupo 11">
                <g id="Grupo_10" data-name="Grupo 10">
                  <path
                    id="Trazado_14"
                    data-name="Trazado 14"
                    d="M7438.072,2098.959a.558.558,0,0,1,.576,0l6.8,3.744c.18.108.4.252.4.468v4.535c0,.288-.216.5-.4.4l-7.092-4.033-7.09,4.033c-.18.107-.4-.109-.4-.4v-4.535c0-.216.216-.36.4-.468Zm0,8.5a.556.556,0,0,1,.576,0l6.8,3.743c.18.109.4.252.4.469v4.535c0,.288-.216.5-.4.4l-7.092-4.031-7.09,4.031c-.18.108-.4-.108-.4-.4v-4.535c0-.217.216-.36.4-.469Z"
                    fill="#000"
                  />
                </g>
              </g>
            </g>
          </svg>
        </button>
        <swiper
          :spaceBetween="20"
          :modules="modules"
          :loop="true"
          :navigation="{
            nextEl: '.button-next',
            prevEl: '.button-prev',
          }"
          :autoplay="{
            delay: 3500 * 1000,
            disableOnInteraction: true,
          }"
          :breakpoints="{
            '@0.25': {
              slidesPerView: 1,
              spaceBetween: 20,
              loop: true,
            },
            '@0.50': {
              slidesPerView: 1,
              spaceBetween: 20,
              loop: true,
            },
            '@0.75': {
              slidesPerView: 2,
              spaceBetween: 20,
              loop: true,
            },

            '@1.00': {
              slidesPerView: 3,
              spaceBetween: 140,
              loop: true,
            },
            '@1.50': {
              slidesPerView: 3,
              spaceBetween: 20,
              loop: true,
            },
          }"
          :speed="400"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="mySwiper w-full"
        >
          <swiper-slide v-for="(activity, index) in itemsCards" :key="index">
            <div
              class="card_container w-full transition duration-200 overflow-hidden"
              @click="modalStore.showCountryModal = activity.countryCode"
              :class="{
                inactive: hoveredIndex !== null && hoveredIndex !== index,
              }"
              @mouseover="handleHover(index)"
              @mouseleave="handleHover(null)"
            >
              <div
                class="card_image h-full w-full bg-cover bg-center bg-no-repeat"
                :style="{ backgroundImage: 'url(' + activity.image + ')' }"
              >
                <a @click="openModal" target="_blank" class="relative cursor-pointer">
                  <div
                    class="card_content h-full flex-col flex justify-center items-center"
                  >
                    <p class="text-xl text-white">Ver Galería</p>
                    <!--<img
                      :src="
                        activity.isTHF == true
                          ? '/images/thf-logo.png'
                          : '/images/atdl-logo.png'
                      "
                      class="mt-5 campaign-logo"
                    />-->
                    <h4 class="text-white text-4xl font-bold text-center mt-5">
                      {{ activity.country }}
                    </h4>
                  </div>
                </a>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <button class="button-next z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.974"
            height="17.746"
            viewBox="0 0 14.974 17.746"
            class="rotate-90"
          >
            <g
              id="Grupo_131"
              data-name="Grupo 131"
              transform="translate(-7430.874 -2098.879)"
            >
              <g id="Grupo_11" data-name="Grupo 11">
                <g id="Grupo_10" data-name="Grupo 10">
                  <path
                    id="Trazado_14"
                    data-name="Trazado 14"
                    d="M7438.072,2098.959a.558.558,0,0,1,.576,0l6.8,3.744c.18.108.4.252.4.468v4.535c0,.288-.216.5-.4.4l-7.092-4.033-7.09,4.033c-.18.107-.4-.109-.4-.4v-4.535c0-.216.216-.36.4-.468Zm0,8.5a.556.556,0,0,1,.576,0l6.8,3.743c.18.109.4.252.4.469v4.535c0,.288-.216.5-.4.4l-7.092-4.031-7.09,4.031c-.18.108-.4-.108-.4-.4v-4.535c0-.217.216-.36.4-.469Z"
                    fill="#000"
                  />
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>
.campaign-logo {
  width: 40%;
  height: auto;
}
.button-next,
.button-prev {
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
}
.button-next svg,
.button-prev svg {
  fill: #000;
  width: 30px;
  height: 30px;
}

.card_image:hover {
  transition: transform 0.8s;
}

.inactive {
  filter: grayscale(100%);
  transition: filter 0.3s;
}

.bg-section {
  background: white;
  position: relative;
}

.card_container {
  width: 100%;
  height: 22rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.card_container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.493);
}

.heking-fest {
  width: 12%;
  height: auto;
}

@media screen and (max-width: 1024px) {
  .heking-fest {
    width: 40%;
  }

  .bg-section::before {
    background-color: rgba(0, 0, 0, 0.493);
  }
}
</style>
